import { MAX_QUANTITY, MIN_QUANTITY, SHIPPING_COST } from '@/constants/pricing';
import type { OrderTotals } from '@/types/pricing';

// Totals are ex-VAT: Stripe Tax computes the charged VAT during checkout.
export function getOrderTotals(
  quantity: number,
  unitPrice: number
): OrderTotals {
  const subtotal = unitPrice * quantity;
  return {
    subtotal,
    shipping: SHIPPING_COST,
    total: subtotal + SHIPPING_COST,
  };
}

export function clampQuantity(quantity: number) {
  return Math.max(MIN_QUANTITY, Math.min(MAX_QUANTITY, quantity));
}

export function isShippingFree() {
  return SHIPPING_COST === 0;
}
